import { useAppContext } from "contexts/AppContext";
import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Image,
  Offcanvas,
  Row,
  Spinner,
} from "react-bootstrap";
import {
  Basket,
  CartPlus,
  CheckCircleFill,
  Collection,
  Dash,
  FileEarmarkDiff,
  HouseDoor,
  PersonVcard,
  Plus,
  XCircleFill,
} from "react-bootstrap-icons";
import ProfileImage from "assets/profile.png";
import useAuth from "hooks/useAuth";
import { useNavigate } from "react-router-dom";
import SingleLink from "./SingleLink";
import DropDownLink from "./DropDownLink";
import DateFormat from "components/DateFormat";
import Logo from "assets/black-logo.png";

const Sidebar = ({ show, setShow }) => {
  const { appState } = useAppContext();
  const { loading, data, logout } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(false);

  const links = [
    { text: "Dashboard", to: "/dashboard", Icon: HouseDoor },
    { text: "Contacts", to: "/dashboard/contacts", Icon: PersonVcard },
    { text: "Orders", to: "/dashboard/sales/orders", Icon: Basket },
    { text: "New Order", to: "/dashboard/sales/orders/form", Icon: CartPlus },
    {
      text: "Drafts",
      to: "/dashboard/sales/orders/draft",
      Icon: FileEarmarkDiff,
    },
    {
      text: "Outbox",
      to: "/dashboard/sales/orders/outbox",
      Icon: Collection,
    },
  ];

  const doLogout = () => {
    logout();
  };

  useEffect(() => {
    if (!loading && data) {
      navigate("/auth/login");
    }
  }, [loading]);

  return (
    <React.Fragment>
      <Offcanvas show={show} onHide={() => setShow(false)}>
        <Offcanvas.Header closeButton closeLabel="">
          <h3 className="my-0 mx-2"></h3>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Row>
            <Image
              src={appState.auth.user?.image || ProfileImage}
              roundedCircle
              className="w-25 p-0 mx-1"
            />
            <span className="w-auto">
              <h2 className="m-0">{appState.auth.user?.name}</h2>
              <h5>{appState.auth.user?.role.name}</h5>
              <h5>{appState.auth.user?.entity.name}</h5>
            </span>
            <Row className="justify-content-end">
              {!profile && (
                <Plus
                  onClick={() => setProfile(true)}
                  size={25}
                  className="w-auto"
                />
              )}
              {profile && (
                <Dash
                  onClick={() => setProfile(false)}
                  size={25}
                  className="w-auto"
                />
              )}
              {profile && (
                <Container>
                  <p>Email: {appState.auth.user?.email}</p>
                  <p>Phone: {appState.auth.user?.mobile}</p>
                  <p>
                    Verified:{" "}
                    {appState.auth.user?.verified ? (
                      <CheckCircleFill color="green" size={18} />
                    ) : (
                      <XCircleFill color="darkred" size={18} />
                    )}
                  </p>
                  <p>
                    Last Login:{" "}
                    <DateFormat
                      value={appState.auth.user?.lastLogin}
                      withTime
                    />
                  </p>
                </Container>
              )}
            </Row>
          </Row>
          <Row className="my-3 py-3 px-1 border-top">
            {links.map((link) => (
              <React.Fragment key={link.to}>
                {link.children && <DropDownLink link={link} />}
                {!link.children && <SingleLink link={link} setShow={setShow} />}
              </React.Fragment>
            ))}
            <Button
              className="mt-5"
              variant="danger"
              onClick={doLogout}
              disabled={loading}
            >
              {!loading && "Log out"}
              {loading && <Spinner className="fa-spin" />}
            </Button>
          </Row>
        </Offcanvas.Body>
        <Offcanvas.Header>
          <Image src={Logo} width="35em" />
          {import.meta.env.VITE_VERSION}
        </Offcanvas.Header>
      </Offcanvas>
    </React.Fragment>
  );
};

export default Sidebar;
